module.exports = __webpack_public_path__ + "media/images/faces/male/25-961840d03fde60081110b845f74dcc6f.jpg";